// Interim English UI dictionary. Keep keys stable so locale resources can be
// introduced later without changing component behavior.
const UI_TEXT = {
  SEARCH_PLACEHOLDER: 'Search by subject, sender, ticket ID…',
  NOTIFICATIONS_PANEL_TOGGLE: 'Toggle notifications panel',
  NEW_TICKET_NOTIFICATIONS: 'New ticket notifications',
  BY_CATEGORY: 'By category',
  BY_STATUS: 'By status',
  PIC_WORKLOAD: 'PIC workload',
  AGING_ANALYSIS_RANGE_SUBTITLE: 'Tickets closed after SLA deadline from {startDate} to {endDate}',
  AGING_ANALYSIS_DEFAULT_SUBTITLE: 'Tickets closed after SLA deadline (business days)',
  EXPORT_BUTTON: 'Export',
  EXPORT_DIALOG_TITLE: 'Export requests',
  EXPORT_STEP_COLUMNS_TITLE: 'Choose columns',
  EXPORT_STEP_COLUMNS_SUBTITLE: 'Select the columns to include in the exported file.',
  EXPORT_SELECT_ALL: 'Select all',
  EXPORT_CLEAR_ALL: 'Clear all',
  EXPORT_COLUMNS_SELECTED: '{count} of {total} columns selected',
  EXPORT_STEP_PREVIEW_TITLE: 'Preview',
  EXPORT_STEP_PREVIEW_SUBTITLE: 'Showing the first {shown} of {total} matching tickets.',
  EXPORT_FETCHING: 'Fetching tickets that match your current filters…',
  EXPORT_FETCH_ERROR: 'Could not load tickets for export.',
  EXPORT_TOO_MANY_ROWS: 'This export would include more than {max} tickets. Narrow your filters and try again.',
  EXPORT_EMPTY: 'No tickets match your current filters.',
  EXPORT_BACK: 'Back',
  EXPORT_NEXT: 'Next',
  EXPORT_CANCEL: 'Cancel',
  EXPORT_CONFIRM: 'Export {count} tickets',
  EXPORT_GENERATING: 'Generating file…',
  EXPORT_GENERATE_ERROR: 'Could not generate the Excel file.',
  EXPORT_NO_COLUMNS: 'Select at least one column to continue.',
  EXPORT_COL_ID: 'Ticket ID',
  EXPORT_COL_TITLE: 'Subject',
  EXPORT_COL_STATUS: 'Status',
  EXPORT_COL_CATEGORY: 'Category',
  EXPORT_COL_PRIORITY: 'Priority',
  EXPORT_COL_CUSTOMERS: 'Customers',
  EXPORT_COL_SENDER_NAME: 'Sender',
  EXPORT_COL_SENDER_EMAIL: 'Sender email',
  EXPORT_COL_EMAILS: 'Emails',
  EXPORT_COL_MAIN_PIC: 'Main PIC Name',
  EXPORT_COL_MAIN_PIC_EMAIL: 'Main PIC email',
  EXPORT_COL_BACKUP_PIC: 'Backup PIC Name',
  EXPORT_COL_BACKUP_PIC_EMAIL: 'Backup PIC email',
  EXPORT_COL_RECEIVED: 'Received',
  EXPORT_COL_START_DATE: 'Start date',
  EXPORT_COL_END_DATE: 'End date',
  EXPORT_COL_DUE_DATE: 'Due date',
  EXPORT_COL_OVERDUE: 'Overdue',
  EXPORT_COL_RESOLUTION_TIME: 'Resolution time',
};

export function uiText(key, values = {}) {
  return Object.entries(values).reduce(
    (text, [name, value]) => text.split(`{${name}}`).join(String(value)),
    UI_TEXT[key] || key,
  );
}
